import { Link } from 'react-router-dom';
import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-warm-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center pt-20">
        <div className="text-center px-4">
          <div className="w-20 h-20 bg-warm-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <span className="w-10 h-10 flex items-center justify-center">
              <i className="ri-home-smile-line text-dark-300 text-3xl" />
            </span>
          </div>
          <h1 className="font-display font-bold text-4xl md:text-5xl text-dark-900 mb-4">
            404
          </h1>
          <p className="text-dark-500 text-lg mb-2">Page Not Found</p>
          <p className="text-dark-400 text-sm max-w-sm mx-auto mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-brand-500 text-white font-medium rounded-full hover:bg-brand-600 transition-colors"
          >
            <i className="ri-arrow-left-line" />
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}